import "./index.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { Toaster } from "sonner";
import { listenForAppLinks } from "@/lib/app-links";
import { queryClient } from "@/lib/queries";
import { loadSessionToken } from "@/lib/session-token";
import { refreshAppOnce } from "@/lib/stale-app";
import { router } from "@/router";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

// If a page file is missing because this phone is running an older copy of the app, get the newest.
window.addEventListener("vite:preloadError", (event) => {
  if (refreshAppOnce()) event.preventDefault();
});

// The apps restore their saved session before the first request goes out.
await loadSessionToken();
listenForAppLinks((path) => void router.navigate(path));

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster
        position="top-center"
        richColors
        closeButton
        theme="system"
        // Keep messages clear of the phone's clock and camera notch.
        offset={{ top: "calc(env(safe-area-inset-top) + 12px)" }}
        mobileOffset={{ top: "calc(env(safe-area-inset-top) + 12px)" }}
      />
    </QueryClientProvider>
  </StrictMode>,
);
